"use client";

import React, { useState } from "react";
import AdmissionEnquiryModal from "./AdmissionEnquiryModal";

const steps = [
	{
		number: "01",
		title: "Research & Shortlist",
		description: "Shortlist the right country and medical universities based on budget.",
	},
	{
		number: "02",
		title: "Eligibility Check",
		description: "Verify NEET score, PCB percentage and admission requirements.",
	},
	{
		number: "03",
		title: "Apply & Documents",
		description: "Fill application form and submit all required documents.",
	},
	{
		number: "04",
		title: "Offer Letter",
		description: "Receive offer letter and confirm your admission seat.",
	},
	{
		number: "05",
		title: "Fee Payment",
		description: "Pay tuition fees and officially secure your seat.",
	},
	{
		number: "06",
		title: "Student Visa",
		description: "Apply for student visa and complete all formalities.",
	},
	{
		number: "07",
		title: "Pre-Departure",
		description: "Pre-departure briefing and travel preparation.",
	},
	{
		number: "08",
		title: "University Reg.",
		description: "Register at university and begin your MBBS course.",
	},
];

const StepCard = ({ step }) => {
	const [hovered, setHovered] = useState(false);

	return (
		<div
			className={`bg-white rounded-2xl p-5 sm:p-6 border transition-transform duration-200 ${hovered ? "-translate-y-1 shadow-2xl border-blue-100" : "shadow-lg"
				}`}
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
		>
			<div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full mx-auto mb-3 sm:mb-4 flex items-center justify-center bg-gradient-to-b from-sky-50 to-white border-2 border-blue-100 text-blue-600 font-extrabold text-sm sm:text-base">
				{step.number}
			</div>

			<h3 className="text-center text-base sm:text-lg font-semibold text-blue-700 mb-2 sm:mb-3">
				{step.title}
			</h3>
			<p className="text-center text-xs sm:text-sm text-slate-600 leading-relaxed">
				{step.description}
			</p>
		</div>
	);
};

export default function AddmissionProcess() {
	const [btnHovered, setBtnHovered] = useState(false);
	const [showModal, setShowModal] = useState(false);

	const [form, setForm] = useState({
		name: "",
		email: "",
		phone: "",
		country: "",
	});
	const [submitting, setSubmitting] = useState(false);
	const [message, setMessage] = useState("");

	const apiBase = process.env.NEXT_PUBLIC_ADMIN_URL || "";

	const openModal = () => setShowModal(true);
	const closeModal = () => setShowModal(false);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setForm((s) => ({ ...s, [name]: value }));
	};

	const normalizeMobile = (phone) => phone.replace(/\D/g, "");

	const handleSubmit = async (e) => {
		e.preventDefault();
		setSubmitting(true);
		setMessage("");
		try {
			const [firstName, ...lastNameParts] = form.name.trim().split(/\s+/);
			const payload = {
				name: form.name.trim(),
				firstName: firstName || "",
				lastName: lastNameParts.join(" "),
				email: form.email.trim(),
				mobile: normalizeMobile(form.phone),
				country: form.country,
				leadSource: "mbbs-abroad",
			};

			const response = await fetch(`${apiBase}/api/leads`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(payload),
			});

			if (!response.ok) throw new Error("Failed to submit lead");

			setMessage("Thanks — we received your enquiry. We will contact you soon.");
			setForm({ name: "", email: "", phone: "", country: "" });
		} catch (err) {
			console.warn(err);
			setMessage("Submission failed — please try again later.");
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<section className="py-12 sm:py-16 bg-gradient-to-b from-sky-50 to-white">
			<div className="max-w-6xl mx-auto px-4 sm:px-6">
				<h2 className="text-center text-2xl sm:text-3xl font-extrabold text-slate-900">
					Study MBBS Abroad{" "}
					<span style={{ color: "#FF9245" }}>Admission Process</span>
				</h2>
				<p className="text-center text-sm sm:text-base text-slate-600 font-medium mt-3 mb-8">
					8 simple steps to your dream medical career abroad
				</p>

				<div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-4">
					{steps.map((step) => (
						<StepCard key={step.number} step={step} />
					))}
				</div>

				<div className="text-center mt-8">
					<button
						type="button"
						onClick={openModal}
						className="inline-flex items-center gap-3 px-5 sm:px-6 py-2.5 sm:py-3 rounded-full bg-transparent text-sm sm:text-base font-semibold text-[#ff9245] hover:bg-[#ff9245] hover:text-white transition-shadow focus:outline-none focus:ring-2 focus:ring-[#ff9245]/25"
						style={{ border: "2px solid #ff9245", boxSizing: "border-box" }}
					>
						Start Your Journey Today
						<span aria-hidden>→</span>
					</button>
				</div>

				<AdmissionEnquiryModal
					open={showModal}
					onClose={closeModal}
					form={form}
					setForm={setForm}
					onSubmit={handleSubmit}
					submitting={submitting}
					message={message}
				/>
			</div>
		</section>
	);
}